"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.broker = exports.warnMessage = void 0;
var message_broker_1 = require("../../message-broker/message-broker");
exports.warnMessage = [
    'The window-messages broker is a singleton service that has already been initialized for this window or global context.',
    'Subsquent initialize attempts are ignored.'
].join('');
/**
 * Returns the existing MessageBroker instance or creates an instance if it does not exist.
 * @param name An arbitrary label given to the broker for reference purpose only.
 * @param contract An contract that defined emitted and accepted events.
 * @param warnOnMultipleInstanceCreationAttempts defaults to true
 * @returns MessageBroker instance
 */
var broker = function (name, contract, settings, debug) {
    if (settings === void 0) { settings = {}; }
    if (debug === void 0) { debug = false; }
    var env = globalThis;
    if (env.wmBroker && env.wmBroker instanceof message_broker_1.MessageBroker) {
        if (debug)
            console.warn(exports.warnMessage);
        return env.wmBroker;
    }
    env.wmBroker = new message_broker_1.MessageBroker(name, contract, settings, debug);
    return env.wmBroker;
};
exports.broker = broker;
